var $ = require('jquery');

var Print = function Print($element, options) {
	var $printActions = $('[data-print="true"]');
	if($printActions.length) {
		$printActions.click(function(e) {
			e.preventDefault();
			window.print();
		});
	}
}

module.exports = Print;